import { z } from "zod";

export const MIN_PAGE_COUNT = 20;
const MAX_PAGE_COUNT = 380;
const PAGE_STEP = 2;

const SpecificationSchema = z.object({
  pages_spec: z
    .object({
      min_page_count: z.number().optional(),
      max_page_count: z.number().optional(),
      page_count_mod: z.number().optional(),
    })
    .optional(),
});

export type PageCountBounds = { min: number; max: number; step: number };

// Page-count min/max/step for a product, read from its specification with sensible fallbacks.
export function getPageCountBounds(specification?: unknown): PageCountBounds {
  const parsed = SpecificationSchema.safeParse(specification);
  const pagesSpec = parsed.success ? parsed.data.pages_spec : undefined;
  return {
    min: pagesSpec?.min_page_count ?? MIN_PAGE_COUNT,
    max: pagesSpec?.max_page_count ?? MAX_PAGE_COUNT,
    step: pagesSpec?.page_count_mod ?? PAGE_STEP,
  };
}

// Snaps a page count to the nearest valid value: within [min, max] and on the step grid from min.
export function clampPageCount(value: number, { min, max, step }: PageCountBounds): number {
  const clamped = Math.min(Math.max(value, min), max);
  const steps = Math.round((clamped - min) / step);
  const snapped = min + steps * step;
  return snapped > max ? snapped - step : snapped;
}
